import Error from '../../../js/model/Error';
import ListActionErrors from './errors/ListActionErrors.js';
import axios from 'axios';

export default class ListBatchProcessingRepository {
    static executeClubBatchAction(listId, params, isTestRun) {
        return new Promise((resolve, reject) => {
            let data = {
                action: params.action,
                isTestRun: isTestRun,
                listActionDto: params,
            };

            axios
                .post(`/club/lists/${listId}/executeBatch`, data)
                .then((response) => resolve(ListActionErrors.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
